(function () {
  'use strict';

  if (window.OpHeaderNavigationLoaded) return;
  window.OpHeaderNavigationLoaded = true;

  var GREEN = '#30b259';
  var GREEN_DARK = '#238843';
  var GREEN_INK = '#173f28';
  var GREEN_SOFT = '#f1fbf5';
  var SALE = '#ef534a';
  var SALE_DARK = '#dc4038';

  function setImportant(element, property, value) {
    if (!element || !element.style) return;
    if (element.style.getPropertyValue(property) === value &&
        element.style.getPropertyPriority(property) === 'important') return;
    element.style.setProperty(property, value, 'important');
  }

  function findRapidSearchSlot() {
    var icons = document.querySelector('#SiteHeader .header-item--icons .site-nav__icons');
    if (!icons) return null;

    var children = Array.prototype.slice.call(icons.children);
    var brands = icons.querySelector('.op-header-brands');
    var slot = null;

    children.some(function (child) {
      if (!child || child === brands || child.classList.contains('site-nav__link')) return false;

      var isRapid = false;
      if (child.matches) {
        isRapid = child.matches('form.rps-csb-form-container, .rps-csb-form-container, [class*="rps-csb"], [class*="rapid-search"]');
      }
      if (!isRapid && child.querySelector) {
        isRapid = !!child.querySelector('form.rps-csb-form-container, .rps-csb-form-container, input[placeholder="Find Your Pet\'s Favourites"], [class*="rps-csb"]');
      }

      if (isRapid) {
        slot = child;
        return true;
      }
      return false;
    });

    if (slot) slot.classList.add('op-rapid-search-slot');
    return slot;
  }

  function syncHeaderOrder() {
    var icons = document.querySelector('#SiteHeader .header-item--icons .site-nav__icons');
    if (!icons) return;

    var rapid = findRapidSearchSlot();
    var brands = icons.querySelector('.op-header-brands');
    var account = icons.querySelector('a[href*="/account"]');
    var cart = icons.querySelector('a[href*="/cart"]');

    if (rapid) {
      setImportant(rapid, 'order', '10');
      setImportant(rapid, 'flex', '1 1 0');
      setImportant(rapid, 'width', 'auto');
      setImportant(rapid, 'max-width', 'none');
      setImportant(rapid, 'min-width', '280px');
      setImportant(rapid, 'margin', '0 12px 0 0');
    }

    if (brands) {
      setImportant(brands, 'order', '20');
      setImportant(brands, 'flex', '0 0 auto');
      setImportant(brands, 'width', 'auto');
      setImportant(brands, 'min-width', '0');
      setImportant(brands, 'margin', '0 10px 0 0');
    }

    if (account) setImportant(account, 'order', '30');
    if (cart) setImportant(cart, 'order', '40');
  }

  function paintTopLink(link, active) {
    if (!link) return;
    var isSale = link.classList.contains('op-nav-toplink--sale') || link.getAttribute('data-op-nav-top') === 'sale';
    var item = link.closest ? link.closest('li') : null;

    if (item) {
      setImportant(item, 'background', 'transparent');
      setImportant(item, 'background-color', 'transparent');
      setImportant(item, 'border-color', 'transparent');
      setImportant(item, 'box-shadow', 'none');
    }

    setImportant(link, 'display', 'flex');
    setImportant(link, 'align-items', 'center');
    setImportant(link, 'justify-content', 'center');
    setImportant(link, 'text-transform', 'none');
    setImportant(link, 'letter-spacing', '0');

    if (isSale) {
      setImportant(link, 'color', '#ffffff');
      setImportant(link, 'background', active ? SALE_DARK : SALE);
      setImportant(link, 'background-color', active ? SALE_DARK : SALE);
      setImportant(link, 'border-color', active ? SALE_DARK : SALE);
    } else {
      setImportant(link, 'color', active ? GREEN_DARK : GREEN_INK);
      setImportant(link, 'background', active ? GREEN_SOFT : '#ffffff');
      setImportant(link, 'background-color', active ? GREEN_SOFT : '#ffffff');
      setImportant(link, 'border-color', active ? GREEN_DARK : GREEN);
    }

    var icon = link.querySelector ? link.querySelector('.op-nav-icon') : null;
    if (icon) setImportant(icon, 'color', isSale ? '#ffffff' : GREEN_DARK);
  }

  function initialiseTopNavigation(scope) {
    scope = scope || document;
    if (!scope.querySelectorAll) return;

    Array.prototype.forEach.call(scope.querySelectorAll('.op-nav-toplink'), function (link) {
      paintTopLink(link, false);

      if (link.getAttribute('data-op-nav-colour-ready') === 'true') return;
      link.setAttribute('data-op-nav-colour-ready', 'true');

      link.addEventListener('pointerenter', function () { paintTopLink(link, true); });
      link.addEventListener('pointerleave', function () { paintTopLink(link, false); });
      link.addEventListener('focus', function () { paintTopLink(link, true); });
      link.addEventListener('blur', function () { paintTopLink(link, false); });
    });
  }

  function qikifyRootLinks(scope) {
    scope = scope || document;
    if (!scope.querySelectorAll) return [];

    var selector = [
      '.tmenu_wrapper li.tmenu_item--root > a.tmenu_item_link',
      '.tmenu_wrapper li.tmenu_item_level_0 > a.tmenu_item_link'
    ].join(',');

    return Array.prototype.slice.call(scope.querySelectorAll(selector)).filter(function (link, index, links) {
      return links.indexOf(link) === index;
    });
  }

  function isQikifySaleLink(link) {
    if (!link) return false;
    var labelNode = link.querySelector('.tmenu_item_text, .tmenu_item_text_label, .tmenu_item_title');
    var label = (labelNode ? labelNode.textContent : link.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
    var href = (link.getAttribute('href') || '').toLowerCase();
    return label === 'sale' || label.indexOf('sale') === 0 || /(^|\/)sale(?:$|[/?#-])/.test(href);
  }

  function paintQikifyRootLink(link, active) {
    if (!link) return;
    var item = link.closest('li.tmenu_item--root, li.tmenu_item_level_0');
    var isSale = isQikifySaleLink(link);

    if (item) {
      item.classList.toggle('op-qikify-sale', isSale);
      item.classList.add('op-qikify-root');
      setImportant(item, 'background', 'transparent');
      setImportant(item, 'background-color', 'transparent');
      setImportant(item, 'border', '0px');
      setImportant(item, 'box-shadow', 'none');
      setImportant(item, 'margin', '0px');
    }

    setImportant(link, 'display', 'flex');
    setImportant(link, 'align-items', 'center');
    setImportant(link, 'justify-content', 'center');
    setImportant(link, 'gap', '8px');
    setImportant(link, 'width', '100%');
    setImportant(link, 'min-height', '54px');
    setImportant(link, 'padding', '10px 13px');
    setImportant(link, 'background-image', 'none');
    setImportant(link, 'border-style', 'solid');
    setImportant(link, 'border-width', '1.5px');
    setImportant(link, 'border-radius', '9px');
    setImportant(link, 'font-size', '13px');
    setImportant(link, 'font-weight', '700');
    setImportant(link, 'line-height', '1.15');
    setImportant(link, 'letter-spacing', '0px');
    setImportant(link, 'text-transform', 'none');
    setImportant(link, 'white-space', 'nowrap');
    setImportant(link, 'opacity', '1');

    if (isSale) {
      setImportant(link, 'color', '#ffffff');
      setImportant(link, 'background', active ? SALE_DARK : SALE);
      setImportant(link, 'background-color', active ? SALE_DARK : SALE);
      setImportant(link, 'border-color', active ? SALE_DARK : SALE);
      setImportant(link, 'box-shadow', '0 5px 13px rgba(239, 83, 74, .20)');
    } else {
      setImportant(link, 'color', active ? GREEN_DARK : GREEN_INK);
      setImportant(link, 'background', active ? GREEN_SOFT : '#ffffff');
      setImportant(link, 'background-color', active ? GREEN_SOFT : '#ffffff');
      setImportant(link, 'border-color', active ? GREEN_DARK : GREEN);
      setImportant(link, 'box-shadow', active ? '0 6px 15px rgba(48, 178, 89, .13)' : '0 2px 6px rgba(19, 71, 37, .035)');
    }
  }

  function initialiseQikifyTopNavigation(scope) {
    qikifyRootLinks(scope || document).forEach(function (link) {
      var activeNow = (link.matches && link.matches(':hover')) || document.activeElement === link;
      paintQikifyRootLink(link, activeNow);

      if (link.getAttribute('data-op-qikify-colour-ready') === 'true') return;
      link.setAttribute('data-op-qikify-colour-ready', 'true');

      link.addEventListener('pointerenter', function () { paintQikifyRootLink(link, true); });
      link.addEventListener('pointerleave', function () { paintQikifyRootLink(link, false); });
      link.addEventListener('focus', function () { paintQikifyRootLink(link, true); });
      link.addEventListener('blur', function () { paintQikifyRootLink(link, false); });
    });
  }


  /* ---------------------------------------------------------
     V8 universal top-level menu painter
     Ormskirk Pets has legacy/app menu code that can repaint the
     desktop menu after the theme has loaded.  This deliberately
     identifies the visible ROOT links by their label and applies
     the approved Design 1 appearance directly to the real element,
     regardless of whether it is the native Impulse nav, Buddha
     Mega Menu or Qikify.  Dropdown descendants are never touched.
     --------------------------------------------------------- */
  var OP_ROOT_LABELS = {
    'dogs': true,
    'cats': true,
    'small animals': true,
    'birds': true,
    'equine': true,
    'agricultural': true,
    'fish': true,
    'reptiles': true,
    'clearance': true,
    'sale': true
  };

  function cleanNavLabel(link) {
    if (!link) return '';
    var labelNode = link.querySelector('.op-nav-text, .mm-title, .tmenu_item_text, .tmenu_item_text_label, .tmenu_item_title');
    var text = labelNode ? labelNode.textContent : link.textContent;
    return (text || '')
      .replace(/[\u00a0\n\r\t]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function rootMenuCandidates(scope) {
    scope = scope || document;
    if (!scope.querySelectorAll) return [];

    var roots = Array.prototype.slice.call(scope.querySelectorAll([
      '#SiteHeader ul.op-nav-primary',
      '#SiteHeader ul.horizontal-mega-menu',
      '#SiteHeader ul.site-navigation.horizontal-mega-menu',
      '#SiteHeader .tmenu_wrapper ul.tmenu_nav'
    ].join(',')));

    var links = [];
    roots.forEach(function (root) {
      Array.prototype.forEach.call(root.children || [], function (item) {
        if (!item || item.tagName !== 'LI') return;
        var link = null;
        Array.prototype.some.call(item.children || [], function (child) {
          if (child && child.tagName === 'A') {
            link = child;
            return true;
          }
          return false;
        });
        if (!link) return;
        var label = cleanNavLabel(link);
        if (!OP_ROOT_LABELS[label]) return;
        if (links.indexOf(link) === -1) links.push(link);
      });
    });

    /* Fallback for menu apps that wrap the root list in an
       unexpected container but retain the top-level href/text. */
    if (!links.length) {
      Array.prototype.forEach.call(scope.querySelectorAll('#SiteHeader a'), function (link) {
        var label = cleanNavLabel(link);
        if (!OP_ROOT_LABELS[label]) return;
        var item = link.closest && link.closest('li');
        if (!item) return;
        var parentList = item.parentElement;
        if (!parentList) return;
        var rect = link.getBoundingClientRect ? link.getBoundingClientRect() : null;
        if (rect && rect.width > 40 && rect.height > 20 && rect.top < 280) {
          if (links.indexOf(link) === -1) links.push(link);
        }
      });
    }
    return links;
  }

  function clearAppPaintInsideRootLink(link) {
    if (!link || !link.querySelectorAll) return;
    Array.prototype.forEach.call(link.querySelectorAll('.mm-title, .tmenu_item_text, .tmenu_item_text_label, .tmenu_item_title, .op-nav-text'), function (node) {
      setImportant(node, 'background', 'transparent');
      setImportant(node, 'background-color', 'transparent');
      setImportant(node, 'background-image', 'none');
      setImportant(node, 'color', 'inherit');
    });
  }

  function paintUniversalRootLink(link, active) {
    if (!link) return;
    var label = cleanNavLabel(link);
    if (!OP_ROOT_LABELS[label]) return;

    var isSale = label === 'sale';
    var item = link.closest ? link.closest('li') : null;

    link.classList.add('op-force-nav-link');
    link.classList.toggle('op-force-nav-sale-link', isSale);

    if (item) {
      item.classList.add('op-force-nav-root');
      item.classList.toggle('op-force-nav-sale', isSale);
      setImportant(item, 'background', 'transparent');
      setImportant(item, 'background-color', 'transparent');
      setImportant(item, 'background-image', 'none');
      setImportant(item, 'border-color', 'transparent');
      setImportant(item, 'box-shadow', 'none');
    }

    setImportant(link, 'display', 'flex');
    setImportant(link, 'align-items', 'center');
    setImportant(link, 'justify-content', 'center');
    setImportant(link, 'gap', '8px');
    setImportant(link, 'width', '100%');
    setImportant(link, 'min-height', '54px');
    setImportant(link, 'padding', '10px 13px');
    setImportant(link, 'background-image', 'none');
    setImportant(link, 'border-style', 'solid');
    setImportant(link, 'border-width', '1.5px');
    setImportant(link, 'border-radius', '9px');
    setImportant(link, 'font-size', '13px');
    setImportant(link, 'font-weight', '700');
    setImportant(link, 'line-height', '1.15');
    setImportant(link, 'letter-spacing', '0px');
    setImportant(link, 'text-transform', 'none');
    setImportant(link, 'white-space', 'nowrap');
    setImportant(link, 'opacity', '1');

    if (isSale) {
      setImportant(link, 'color', '#ffffff');
      setImportant(link, 'background', active ? SALE_DARK : SALE);
      setImportant(link, 'background-color', active ? SALE_DARK : SALE);
      setImportant(link, 'border-color', active ? SALE_DARK : SALE);
      setImportant(link, 'box-shadow', '0 5px 13px rgba(239, 83, 74, .20)');
    } else {
      setImportant(link, 'color', active ? GREEN_DARK : GREEN_INK);
      setImportant(link, 'background', active ? GREEN_SOFT : '#ffffff');
      setImportant(link, 'background-color', active ? GREEN_SOFT : '#ffffff');
      setImportant(link, 'border-color', active ? GREEN_DARK : GREEN);
      setImportant(link, 'box-shadow', active ? '0 6px 15px rgba(48, 178, 89, .13)' : '0 2px 6px rgba(19, 71, 37, .035)');
    }

    clearAppPaintInsideRootLink(link);

    var icon = link.querySelector('.op-nav-icon');
    if (icon) setImportant(icon, 'color', isSale ? '#ffffff' : GREEN_DARK);
  }

  function initialiseUniversalTopNavigation(scope) {
    rootMenuCandidates(scope || document).forEach(function (link) {
      var activeNow = (link.matches && link.matches(':hover')) || document.activeElement === link;
      paintUniversalRootLink(link, activeNow);

      if (link.getAttribute('data-op-universal-nav-ready') === 'true') return;
      link.setAttribute('data-op-universal-nav-ready', 'true');

      link.addEventListener('pointerenter', function () { paintUniversalRootLink(link, true); });
      link.addEventListener('pointerleave', function () { paintUniversalRootLink(link, false); });
      link.addEventListener('focus', function () { paintUniversalRootLink(link, true); });
      link.addEventListener('blur', function () { paintUniversalRootLink(link, false); });
    });
  }

  function keepRuntimeStyleLast() {
    var style = document.getElementById('op-nav-runtime-override');
    if (!style) {
      style = document.createElement('style');
      style.id = 'op-nav-runtime-override';
      style.textContent = [
        '@media only screen and (min-width:769px){',
        '#SiteHeader .op-force-nav-root{background:transparent!important;background-color:transparent!important;background-image:none!important;border-color:transparent!important;box-shadow:none!important;}',
        '#SiteHeader .op-force-nav-root:before,#SiteHeader .op-force-nav-root:after{background:transparent!important;background-color:transparent!important;background-image:none!important;}',
        '#SiteHeader a.op-force-nav-link:not(.op-force-nav-sale-link){color:'+GREEN_INK+'!important;background:#fff!important;background-color:#fff!important;background-image:none!important;border:1.5px solid '+GREEN+'!important;}',
        '#SiteHeader a.op-force-nav-link:not(.op-force-nav-sale-link):hover,#SiteHeader a.op-force-nav-link:not(.op-force-nav-sale-link):focus{color:'+GREEN_DARK+'!important;background:'+GREEN_SOFT+'!important;background-color:'+GREEN_SOFT+'!important;border-color:'+GREEN_DARK+'!important;}',
        '#SiteHeader a.op-force-nav-sale-link{color:#fff!important;background:'+SALE+'!important;background-color:'+SALE+'!important;background-image:none!important;border:1.5px solid '+SALE+'!important;}',
        '#SiteHeader a.op-force-nav-sale-link:hover,#SiteHeader a.op-force-nav-sale-link:focus{background:'+SALE_DARK+'!important;background-color:'+SALE_DARK+'!important;border-color:'+SALE_DARK+'!important;}',
        '#SiteHeader a.op-force-nav-link>.mm-title,#SiteHeader a.op-force-nav-link>.tmenu_item_text,#SiteHeader a.op-force-nav-link>.tmenu_item_text_label,#SiteHeader a.op-force-nav-link>.tmenu_item_title,#SiteHeader a.op-force-nav-link>.op-nav-text{background:transparent!important;background-color:transparent!important;background-image:none!important;color:inherit!important;}',
        '#SiteHeader a.op-force-nav-link:before,#SiteHeader a.op-force-nav-link:after{background:transparent!important;background-color:transparent!important;background-image:none!important;}',
        '}'
      ].join('');
    }
    if (document.head && document.head.lastElementChild !== style) document.head.appendChild(style);
  }

  function initialiseBrandsMenu(scope) {
    scope = scope || document;

    var roots = [];
    if (scope.matches && scope.matches('[data-op-brands-menu]')) {
      roots.push(scope);
    }
    if (scope.querySelectorAll) {
      Array.prototype.forEach.call(
        scope.querySelectorAll('[data-op-brands-menu]'),
        function (root) { roots.push(root); }
      );
    }

    roots.forEach(function (root) {
      if (!root || root.getAttribute('data-op-brands-ready') === 'true') return;

      var sectionId = root.id.replace('OpBrandsMegaMenu-', '');
      var trigger = document.querySelector('[data-op-brands-trigger="' + sectionId + '"]');
      if (!trigger) return;

      root.setAttribute('data-op-brands-ready', 'true');

      var letterButtons = Array.prototype.slice.call(root.querySelectorAll('[data-op-brand-letter]'));
      var vendorLinks = Array.prototype.slice.call(root.querySelectorAll('[data-op-vendor-letter]'));
      var currentLetter = root.querySelector('[data-op-current-letter]');
      var vendorList = root.querySelector('[data-op-vendor-list]');
      var emptyState = root.querySelector('[data-op-vendor-empty]');
      var emptyLetter = root.querySelector('[data-op-empty-letter]');
      var closeTimer = null;

      function selectLetter(letter) {
        var visibleCount = 0;

        letterButtons.forEach(function (button) {
          var active = button.getAttribute('data-op-brand-letter') === letter;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        vendorLinks.forEach(function (vendorLink) {
          var visible = vendorLink.getAttribute('data-op-vendor-letter') === letter;
          vendorLink.hidden = !visible;
          if (visible) visibleCount += 1;
        });

        if (currentLetter) currentLetter.textContent = letter;
        if (emptyLetter) emptyLetter.textContent = letter;
        if (emptyState) emptyState.hidden = visibleCount !== 0;
        if (vendorList) vendorList.scrollTop = 0;
      }

      function openMenu() {
        window.clearTimeout(closeTimer);
        root.classList.add('is-open');
        root.setAttribute('aria-hidden', 'false');
        trigger.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }

      function closeMenu() {
        window.clearTimeout(closeTimer);
        root.classList.remove('is-open');
        root.setAttribute('aria-hidden', 'true');
        trigger.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }

      function queueClose() {
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(closeMenu, 420);
      }

      letterButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          selectLetter(button.getAttribute('data-op-brand-letter'));
        });
      });

      trigger.addEventListener('pointerenter', openMenu);
      trigger.addEventListener('focus', openMenu);
      trigger.addEventListener('pointerleave', queueClose);
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        if (root.classList.contains('is-open')) closeMenu();
        else openMenu();
      });

      root.addEventListener('pointerenter', function () {
        window.clearTimeout(closeTimer);
      });
      root.addEventListener('pointerleave', queueClose);
      root.addEventListener('focusin', openMenu);
      root.addEventListener('focusout', function (event) {
        if (!root.contains(event.relatedTarget) && event.relatedTarget !== trigger) {
          queueClose();
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && root.classList.contains('is-open')) {
          closeMenu();
          trigger.focus();
        }
      });

      document.addEventListener('click', function (event) {
        if (!root.contains(event.target) && event.target !== trigger && !trigger.contains(event.target)) {
          closeMenu();
        }
      });

      selectLetter(root.getAttribute('data-default-letter') || 'A');
    });
  }

  function initialiseAll(scope) {
    initialiseTopNavigation(scope || document);
    initialiseQikifyTopNavigation(scope || document);
    initialiseUniversalTopNavigation(scope || document);
    keepRuntimeStyleLast();
    initialiseBrandsMenu(scope || document);
    syncHeaderOrder();
  }

  function queueHeaderResync() {
    window.setTimeout(function () { initialiseAll(document); }, 50);
    window.setTimeout(function () { initialiseAll(document); }, 350);
    window.setTimeout(function () { initialiseAll(document); }, 1200);
    window.setTimeout(function () { initialiseAll(document); }, 2500);
    window.setTimeout(function () { initialiseAll(document); }, 5000);
    window.setTimeout(function () { initialiseAll(document); }, 8000);
    window.setTimeout(function () { initialiseAll(document); }, 12000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialiseAll(document);
      queueHeaderResync();
    });
  } else {
    initialiseAll(document);
    queueHeaderResync();
  }

  window.addEventListener('load', function () {
    initialiseAll(document);
    queueHeaderResync();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initialiseAll(event.target);
    queueHeaderResync();
  });

  var headerRepaintQueued = false;
  function queueObservedHeaderRepaint() {
    if (headerRepaintQueued) return;
    headerRepaintQueued = true;
    window.requestAnimationFrame(function () {
      headerRepaintQueued = false;
      initialiseAll(document);
    });
  }

  var headerObserver = new MutationObserver(function (mutations) {
    var relevant = mutations.some(function (mutation) {
      if (mutation.type === 'childList' && (mutation.addedNodes.length || mutation.removedNodes.length)) return true;
      if (mutation.type === 'attributes') {
        var target = mutation.target;
        return !!(target && target.matches && target.matches(
          '.tmenu_wrapper, .tmenu_nav, .tmenu_item--root, .tmenu_item_level_0, a.tmenu_item_link, .horizontal-mega-menu, .buddha-menu-item, .op-nav-primary, .op-force-nav-root, .op-force-nav-link'
        ));
      }
      return false;
    });
    if (relevant) queueObservedHeaderRepaint();
  });

  function observeHeader() {
    var header = document.getElementById('SiteHeader');
    if (!header) return;
    headerObserver.observe(header, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeHeader);
  } else {
    observeHeader();
  }

  /* Legacy Mega Menu may finish its own paint several seconds after
     window.load. Reassert the root-only styling briefly; this stops
     automatically after 20 seconds and does not touch dropdowns. */
  var opNavSafetyRuns = 0;
  var opNavSafetyTimer = window.setInterval(function () {
    opNavSafetyRuns += 1;
    initialiseUniversalTopNavigation(document);
    keepRuntimeStyleLast();
    if (opNavSafetyRuns >= 20) window.clearInterval(opNavSafetyTimer);
  }, 1000);
}());
